import { ReactComponent as LogoImage } from "./LogoImage.svg";

export default function Logo() {
  return <LogoImage height={50} width={50} aria-label="Success Academies" />;
}
